import React from 'react';
import { observer, Observer, inject } from 'mobx-react';
import { toJS, action } from 'mobx';
import moment from 'moment';

import { SiteHeader } from '../component/SiteHeader';
import { SiteFooter } from '../component/SiteFooter';
import { PreventParentScroll } from '../component/PreventParentScroll';
import { Dropdown } from '../component/Dropdown';
import { DayPicker } from '../component/DayPicker';
import { StickInParent } from '../component/StickInParent';

import { fmtPrice, fmtPercent, fmtDatetime, fmtDate, fmtTime } from '../../model/formatters';
import * as constants from '../../model/const';

import translateBase from '../../translate';
let translate = translateBase.bindPage('userBookings');

@inject(stores => ({
  navigation: stores.app.navigation,
  vRecentBookings: stores.app.vRecentBookings,
}))
@observer
export class RecentBookings extends React.Component {

  render() {
    const { navigation, vRecentBookings } = this.props;
    //const currency = 'CHF';

    return (
      <div>
        {/*<div>
          <pre>
            {JSON.stringify(toJS(this.props.searchForm.optLocation), null, 2)}
            {JSON.stringify(toJS(this.props.searchForm.optCategory), null, 2)}
            {JSON.stringify(toJS(this.props.searchForm.optSubcategory), null, 2)}
            {JSON.stringify(toJS(this.props.searchForm.optOrgTimeUnit), null, 2)}
          </pre>
        </div>*/}

        <SiteHeader />

        <StickInParent>{({ ref: sipRef }) => <Observer>{() =>
          <section className="my-bookings-filter-container sticky-container" ref={sipRef}>
            <div className="filter-header-wrapper">
              <div className="wrapper">
                <div className="row">
                  <div className="column-12">
                    {/*<a href="" className="filter">Filters <i className="fa fa-filter" aria-hidden="true"></i></a>*/}
                    {vRecentBookings.displayFilter === constants.BOOKINGS_FILTER_TYPE.ACTIVE &&
                      <a onClick={() => vRecentBookings.setDisplayFilter(constants.BOOKINGS_FILTER_TYPE.ARCHIVED)}
                        className="archive">{translate("archivedBookings", "Archivierte Buchungen")} <i className="fa fa-archive" aria-hidden="true"></i></a>
                    }
                    {vRecentBookings.displayFilter === constants.BOOKINGS_FILTER_TYPE.ARCHIVED &&
                      <a onClick={() => vRecentBookings.setDisplayFilter(constants.BOOKINGS_FILTER_TYPE.ACTIVE)}
                        className="archive">{translate("activeBookings", "Aktiv Buchungen")} <i className="fa fa-archive" aria-hidden="true"></i></a>
                    }
                  </div>
                </div>
              </div>
            </div>
          </section>
        }</Observer>}</StickInParent>


        <section className="my-bookings-container">
          <div className="wrapper">
            <div className="row">
              <div className="column-12">
                <h1 className="mali-blue">{translate("myBookings", "Meine Buchungen")}</h1>
                {!vRecentBookings.recentBookings.length > 0 &&
                  <span className="no-bookings-message">{translate("noBookingsYet", "There are no bookings yet.")}</span>
                }
                {vRecentBookings.recentBookings.length > 0 &&
                  <div className="table myBookingList-table">
                    <div className="tableheader">
                      <div className="tabledata column-1 tablet">
                        {translate("number", "Nummer")}
                      </div>
                      <div className="tabledata column-3">
                        {translate("object", "Mietobjekt")}
                      </div>
                      <div className="tabledata column-2">
                        {translate("start", "Start")}
                      </div>
                      <div className="tabledata column-2 tablet">
                        {translate("end", "Ende")}
                      </div>
                      <div className="tabledata column-2 right mobile">
                        {translate("price", "Preis")}
                      </div>
                      <div className="tabledata column-2">
                        {translate("state", "Status")}
                      </div>
                    </div>

                    {vRecentBookings.recentBookings.map(booking =>
                      <a className={"tablerow" + (booking.statusId === constants.BOOKING_STATUS_TYPE.CANCELLED ? ' cancelled' : ' booked')} onClick={() => navigation.goRecentBookingDetail(booking.id)}>
                        <div className="tabledata column-1 number tablet">
                          {booking.number}
                        </div>
                        <div className="tabledata column-3">
                          {booking.objectName}
                        </div>
                        <div className="tabledata column-2 number">
                          {fmtDatetime(booking.startDate)}
                        </div>
                        <div className="tabledata column-2 number tablet">
                          {fmtDatetime(booking.endDate)}
                        </div>
                        <div className="tabledata column-2 right number mobile">
                          {booking.currency}&nbsp;{fmtPrice(booking.price)}
                        </div>
                        <div className="tabledata column-2">
                          <span>{booking.status}</span>
                        </div>
                      </a>
                    )}
                  </div>
                }
              </div>
            </div>
            {vRecentBookings.canLoadMore && <div className="row load-more">
              <div className="column-12">
                <button onClick={vRecentBookings.loadMore}>{translate("loadMore", "Mehr laden")} <i className="fa fa-refresh"></i></button>
              </div>
            </div>}
          </div>
        </section>

        <SiteFooter />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/visual/view/RecentBookings.js